/**
 * @fileoverview KV FILE アコーディオン
 * @description SP時のみ FILE 1~3 のアコーディオン開閉を制御する。
 *              排他制御により同時に開けるパネルは1つのみ。
 *              PCサイズでは動作せず、トリガーボタンはラベルとして機能する。
 * @see docs/coding-standards.md
 */

/**
 * KV FILEアコーディオンを初期化する。
 * SP（768px以下）のみ動作し、PCでは何もしない。
 * @returns {void}
 */
const initKvFileAccordion = () => {
	const triggers = document.querySelectorAll('.js-kv-file-trigger');
	if (!triggers.length) return;

	const { SP } = window.APP_CONFIG?.BREAKPOINT ?? { SP: 768 };

	/**
	 * 現在のウィンドウ幅がSPブレークポイント以下か判定する。
	 * @returns {boolean} SPサイズの場合はtrue
	 */
	const isSp = () => window.innerWidth <= SP;

	triggers.forEach(trigger => {
		trigger.addEventListener('click', () => {
			// PCではアコーディオン動作をしない
			if (!isSp()) return;

			const item = trigger.closest('.p-home-kv__copy-item');
			const isOpen = item.classList.contains('is-open');

			// 排他制御: 全アイテムを閉じる
			triggers.forEach(t => {
				const other = t.closest('.p-home-kv__copy-item');
				other.classList.remove('is-open');
				t.setAttribute('aria-expanded', 'false');
			});

			// クリックしたアイテムが閉じていた場合のみ開く
			if (!isOpen) {
				item.classList.add('is-open');
				trigger.setAttribute('aria-expanded', 'true');
			}
		});
	});
};

document.addEventListener('DOMContentLoaded', initKvFileAccordion);
